import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCategoryRegistration = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 70,
	height: 70,
	viewBox: "0 0 70 70",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M2 0.5H67.999C68.8274 0.5 69.499 1.17158 69.499 2L69.5 68C69.5 68.8284 68.8284 69.5 68 69.5H2C1.17157 69.5 0.5 68.8284 0.5 68V2C0.5 1.17157 1.17157 0.5 2 0.5ZM3.74902 5.33398C2.36843 5.33413 1.24902 6.45336 1.24902 7.83398V66.541C1.24903 67.9216 2.36844 69.0409 3.74902 69.041H66.25C67.6306 69.0409 68.75 67.9216 68.75 66.541L68.748 7.83301C68.7478 6.45252 67.6286 5.33398 66.248 5.33398H3.74902ZM14 0.958984C12.8451 0.958984 11.75 1.75274 11.75 2.91699C11.75 4.08127 12.8451 4.87598 14 4.87598C15.1548 4.87584 16.25 4.08115 16.25 2.91699C16.25 1.75282 15.1548 0.959122 14 0.958984ZM3.5 0.958984C2.34539 0.958984 1.2503 1.75241 1.25 2.91602C1.25 4.08029 2.34511 4.875 3.5 4.875C4.65469 4.8749 5.75 4.08079 5.75 2.91699C5.75 1.75279 4.65479 0.959088 3.5 0.958984ZM8.75 0.958984C7.59539 0.958984 6.5003 1.75241 6.5 2.91602C6.5 4.08029 7.59511 4.875 8.75 4.875C9.90467 4.87488 11 4.08078 11 2.91699C11 1.75281 9.90477 0.959105 8.75 0.958984Z",
			fill: "#152A58"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2 0.5H67.999C68.8274 0.5 69.499 1.17158 69.499 2L69.5 68C69.5 68.8284 68.8284 69.5 68 69.5H2C1.17157 69.5 0.5 68.8284 0.5 68V2C0.5 1.17157 1.17157 0.5 2 0.5ZM3.74902 5.33398C2.36843 5.33413 1.24902 6.45336 1.24902 7.83398V66.541C1.24903 67.9216 2.36844 69.0409 3.74902 69.041H66.25C67.6306 69.0409 68.75 67.9216 68.75 66.541L68.748 7.83301C68.7478 6.45252 67.6286 5.33398 66.248 5.33398H3.74902ZM14 0.958984C12.8451 0.958984 11.75 1.75274 11.75 2.91699C11.75 4.08127 12.8451 4.87598 14 4.87598C15.1548 4.87584 16.25 4.08115 16.25 2.91699C16.25 1.75282 15.1548 0.959122 14 0.958984ZM3.5 0.958984C2.34539 0.958984 1.2503 1.75241 1.25 2.91602C1.25 4.08029 2.34511 4.875 3.5 4.875C4.65469 4.8749 5.75 4.08079 5.75 2.91699C5.75 1.75279 4.65479 0.959088 3.5 0.958984ZM8.75 0.958984C7.59539 0.958984 6.5003 1.75241 6.5 2.91602C6.5 4.08029 7.59511 4.875 8.75 4.875C9.90467 4.87488 11 4.08078 11 2.91699C11 1.75281 9.90477 0.959105 8.75 0.958984Z",
			stroke: "#152A58"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2 0.5H67.999C68.8274 0.5 69.499 1.17158 69.499 2L69.5 68C69.5 68.8284 68.8284 69.5 68 69.5H2C1.17157 69.5 0.5 68.8284 0.5 68V2C0.5 1.17157 1.17157 0.5 2 0.5ZM3.74902 5.33398C2.36843 5.33413 1.24902 6.45336 1.24902 7.83398V66.541C1.24903 67.9216 2.36844 69.0409 3.74902 69.041H66.25C67.6306 69.0409 68.75 67.9216 68.75 66.541L68.748 7.83301C68.7478 6.45252 67.6286 5.33398 66.248 5.33398H3.74902ZM14 0.958984C12.8451 0.958984 11.75 1.75274 11.75 2.91699C11.75 4.08127 12.8451 4.87598 14 4.87598C15.1548 4.87584 16.25 4.08115 16.25 2.91699C16.25 1.75282 15.1548 0.959122 14 0.958984ZM3.5 0.958984C2.34539 0.958984 1.2503 1.75241 1.25 2.91602C1.25 4.08029 2.34511 4.875 3.5 4.875C4.65469 4.8749 5.75 4.08079 5.75 2.91699C5.75 1.75279 4.65479 0.959088 3.5 0.958984ZM8.75 0.958984C7.59539 0.958984 6.5003 1.75241 6.5 2.91602C6.5 4.08029 7.59511 4.875 8.75 4.875C9.90467 4.87488 11 4.08078 11 2.91699C11 1.75281 9.90477 0.959105 8.75 0.958984Z",
			stroke: "#152A58",
			strokeOpacity: .2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M48.5 10.7083V12.6243H21.5V10.7083H48.5Z",
			fill: "#152A58"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M48.5 10.7083V12.6243H21.5V10.7083H48.5Z",
			stroke: "#152A58"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M48.5 10.7083V12.6243H21.5V10.7083H48.5Z",
			stroke: "#152A58",
			strokeOpacity: .2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M53.749 20.916L53.75 56.375H16.25V20.916H53.749ZM16.998 55.916H52.999V55.416L52.998 21.875V21.375H16.998V55.916Z",
			fill: "#152A58"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M53.749 20.916L53.75 56.375H16.25V20.916H53.749ZM16.998 55.916H52.999V55.416L52.998 21.875V21.375H16.998V55.916Z",
			stroke: "#152A58"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M53.749 20.916L53.75 56.375H16.25V20.916H53.749ZM16.998 55.916H52.999V55.416L52.998 21.875V21.375H16.998V55.916Z",
			stroke: "#152A58",
			strokeOpacity: .2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M48.5 26.75V27.209H21.5V26.75H48.5Z",
			fill: "#152A58"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M48.5 26.75V27.209H21.5V26.75H48.5Z",
			stroke: "#152A58"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M48.5 26.75V27.209H21.5V26.75H48.5Z",
			stroke: "#152A58",
			strokeOpacity: .2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M48.5 31.125V31.584H21.5V31.125H48.5Z",
			fill: "#152A58"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M48.5 31.125V31.584H21.5V31.125H48.5Z",
			stroke: "#152A58"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M48.5 31.125V31.584H21.5V31.125H48.5Z",
			stroke: "#152A58",
			strokeOpacity: .2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M48.5 35.5V35.959H21.5V35.5H48.5Z",
			fill: "#152A58"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M48.5 35.5V35.959H21.5V35.5H48.5Z",
			stroke: "#152A58"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M48.5 35.5V35.959H21.5V35.5H48.5Z",
			stroke: "#152A58",
			strokeOpacity: .2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M48.5 39.875V40.334H21.5V39.875H48.5Z",
			fill: "#152A58"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M48.5 39.875V40.334H21.5V39.875H48.5Z",
			stroke: "#152A58"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M48.5 39.875V40.334H21.5V39.875H48.5Z",
			stroke: "#152A58",
			strokeOpacity: .2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M48.5 44.25V44.709H21.5V44.25H48.5Z",
			fill: "#152A58"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M48.5 44.25V44.709H21.5V44.25H48.5Z",
			stroke: "#152A58"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M48.5 44.25V44.709H21.5V44.25H48.5Z",
			stroke: "#152A58",
			strokeOpacity: .2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.9023 48.8677C25.0589 48.7378 25.3447 48.7382 25.5 48.8677C25.5641 48.9212 25.5751 48.9705 25.5752 48.9985C25.5752 49.0195 25.5695 49.0533 25.5391 49.0913L25.5 49.1304L24.542 49.9282L24.0811 50.313L24.543 50.6968L25.5029 51.4946C25.5669 51.5483 25.578 51.5974 25.5781 51.6255C25.5781 51.6534 25.5675 51.7029 25.5039 51.7563C25.4338 51.8143 25.3244 51.854 25.2031 51.854C25.0777 51.854 24.9738 51.8152 24.9043 51.7573L23.9463 50.9595L23.627 50.6929L23.3066 50.9595L22.3506 51.7563C22.2799 51.8149 22.1737 51.854 22.0498 51.854C21.9576 51.854 21.8745 51.8317 21.8096 51.7964L21.751 51.7573C21.6862 51.7032 21.6748 51.6536 21.6748 51.6255C21.6748 51.6044 21.6815 51.5716 21.7119 51.5337L21.751 51.4946L22.708 50.6968L23.1689 50.312L22.708 49.9282L21.751 49.1304C21.6862 49.0762 21.6748 49.0266 21.6748 48.9985C21.6748 48.9704 21.6864 48.9215 21.751 48.8677L21.75 48.8667C21.8869 48.753 22.1233 48.7397 22.2842 48.8247L22.3477 48.8677L23.3057 49.6655L23.625 49.9321L23.9453 49.6655L24.9023 48.8677Z",
			fill: "#152A58"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.9023 48.8677C25.0589 48.7378 25.3447 48.7382 25.5 48.8677C25.5641 48.9212 25.5751 48.9705 25.5752 48.9985C25.5752 49.0195 25.5695 49.0533 25.5391 49.0913L25.5 49.1304L24.542 49.9282L24.0811 50.313L24.543 50.6968L25.5029 51.4946C25.5669 51.5483 25.578 51.5974 25.5781 51.6255C25.5781 51.6534 25.5675 51.7029 25.5039 51.7563C25.4338 51.8143 25.3244 51.854 25.2031 51.854C25.0777 51.854 24.9738 51.8152 24.9043 51.7573L23.9463 50.9595L23.627 50.6929L23.3066 50.9595L22.3506 51.7563C22.2799 51.8149 22.1737 51.854 22.0498 51.854C21.9576 51.854 21.8745 51.8317 21.8096 51.7964L21.751 51.7573C21.6862 51.7032 21.6748 51.6536 21.6748 51.6255C21.6748 51.6044 21.6815 51.5716 21.7119 51.5337L21.751 51.4946L22.708 50.6968L23.1689 50.312L22.708 49.9282L21.751 49.1304C21.6862 49.0762 21.6748 49.0266 21.6748 48.9985C21.6748 48.9704 21.6864 48.9215 21.751 48.8677L21.75 48.8667C21.8869 48.753 22.1233 48.7397 22.2842 48.8247L22.3477 48.8677L23.3057 49.6655L23.625 49.9321L23.9453 49.6655L24.9023 48.8677Z",
			stroke: "#152A58"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.9023 48.8677C25.0589 48.7378 25.3447 48.7382 25.5 48.8677C25.5641 48.9212 25.5751 48.9705 25.5752 48.9985C25.5752 49.0195 25.5695 49.0533 25.5391 49.0913L25.5 49.1304L24.542 49.9282L24.0811 50.313L24.543 50.6968L25.5029 51.4946C25.5669 51.5483 25.578 51.5974 25.5781 51.6255C25.5781 51.6534 25.5675 51.7029 25.5039 51.7563C25.4338 51.8143 25.3244 51.854 25.2031 51.854C25.0777 51.854 24.9738 51.8152 24.9043 51.7573L23.9463 50.9595L23.627 50.6929L23.3066 50.9595L22.3506 51.7563C22.2799 51.8149 22.1737 51.854 22.0498 51.854C21.9576 51.854 21.8745 51.8317 21.8096 51.7964L21.751 51.7573C21.6862 51.7032 21.6748 51.6536 21.6748 51.6255C21.6748 51.6044 21.6815 51.5716 21.7119 51.5337L21.751 51.4946L22.708 50.6968L23.1689 50.312L22.708 49.9282L21.751 49.1304C21.6862 49.0762 21.6748 49.0266 21.6748 48.9985C21.6748 48.9704 21.6864 48.9215 21.751 48.8677L21.75 48.8667C21.8869 48.753 22.1233 48.7397 22.2842 48.8247L22.3477 48.8677L23.3057 49.6655L23.625 49.9321L23.9453 49.6655L24.9023 48.8677Z",
			stroke: "#152A58",
			strokeOpacity: .2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47.8252 48.7227C47.9819 48.5927 48.2674 48.5924 48.4238 48.7217V48.7227C48.4886 48.7767 48.5 48.8263 48.5 48.8545C48.5 48.8826 48.4894 48.9325 48.4248 48.9863L44.9258 51.9014C44.8554 51.9596 44.7476 51.999 44.625 51.999C44.5326 51.9989 44.4498 51.9773 44.3857 51.9424L44.3281 51.9033L42.5781 50.4443C42.5134 50.3902 42.502 50.3406 42.502 50.3125C42.502 50.2844 42.5137 50.2353 42.5781 50.1816L42.5771 50.1807C42.7141 50.067 42.9505 50.0537 43.1113 50.1387L43.1748 50.1816L44.3057 51.123L44.626 51.3906L44.9453 51.123L47.8252 48.7227Z",
			fill: "#152A58"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47.8252 48.7227C47.9819 48.5927 48.2674 48.5924 48.4238 48.7217V48.7227C48.4886 48.7767 48.5 48.8263 48.5 48.8545C48.5 48.8826 48.4894 48.9325 48.4248 48.9863L44.9258 51.9014C44.8554 51.9596 44.7476 51.999 44.625 51.999C44.5326 51.9989 44.4498 51.9773 44.3857 51.9424L44.3281 51.9033L42.5781 50.4443C42.5134 50.3902 42.502 50.3406 42.502 50.3125C42.502 50.2844 42.5137 50.2353 42.5781 50.1816L42.5771 50.1807C42.7141 50.067 42.9505 50.0537 43.1113 50.1387L43.1748 50.1816L44.3057 51.123L44.626 51.3906L44.9453 51.123L47.8252 48.7227Z",
			stroke: "#152A58"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47.8252 48.7227C47.9819 48.5927 48.2674 48.5924 48.4238 48.7217V48.7227C48.4886 48.7767 48.5 48.8263 48.5 48.8545C48.5 48.8826 48.4894 48.9325 48.4248 48.9863L44.9258 51.9014C44.8554 51.9596 44.7476 51.999 44.625 51.999C44.5326 51.9989 44.4498 51.9773 44.3857 51.9424L44.3281 51.9033L42.5781 50.4443C42.5134 50.3902 42.502 50.3406 42.502 50.3125C42.502 50.2844 42.5137 50.2353 42.5781 50.1816L42.5771 50.1807C42.7141 50.067 42.9505 50.0537 43.1113 50.1387L43.1748 50.1816L44.3057 51.123L44.626 51.3906L44.9453 51.123L47.8252 48.7227Z",
			stroke: "#152A58",
			strokeOpacity: .2
		})
	]
});
export default SvgCategoryRegistration;
